// VPN traffic stats removed.
export const useVPNTrafficStats = () => ({ data: null as any, isLoading: false });
